import { SYSTEM_VARIABLES } from "@velizhanin-dev/bot-scenario"
import { Copy, Plus } from "lucide-react"
import { useState } from "react"
import { toast } from "sonner"
import { VARIABLE_TYPE_LABELS, VariablesDialog } from "@/features/edit-scenario-draft"
import { Button } from "@/shared/ui/button"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/shared/ui/table"
import { WithDraft, WorkspaceSection } from "@/widgets/bot-workspace"

const SUBTITLE =
	// biome-ignore lint/suspicious/noTemplateCurlyInString: так в конструкторе записываются переменные
	"Базовые переменные есть у каждого пользователя, остальные бот заполняет ответами в воронках. Нажмите на код, чтобы скопировать его и вставить в текст сообщения."

const code = (name: string) => `\${${name}}`

function CodeCell({ name }: { name: string }) {
	return (
		<TableCell>
			<Button
				type="button"
				variant="ghost"
				title="Скопировать"
				className="h-auto gap-1.5 px-1.5 py-0.5 font-mono text-xs"
				onClick={() => {
					void navigator.clipboard?.writeText(code(name))
					toast.success(`${code(name)} скопирован`)
				}}
			>
				{code(name)}
				<Copy className="size-3 text-muted-foreground" />
			</Button>
		</TableCell>
	)
}

/** «Конструктор → Переменные»: базовые и созданные переменные с кодами для текстов. */
export function VariablesPage() {
	const [open, setOpen] = useState(false)
	return (
		<WithDraft title="Переменные" subtitle={SUBTITLE}>
			{({ draft, actions }) => (
				<WorkspaceSection
					title="Переменные"
					subtitle={SUBTITLE}
					actions={
						<Button className="rounded-xl" onClick={() => setOpen(true)}>
							<Plus />
							Создать
						</Button>
					}
				>
					<div className="overflow-x-auto rounded-2xl border border-border bg-card">
						<Table>
							<TableHeader>
								<TableRow>
									<TableHead>Название</TableHead>
									<TableHead>Код</TableHead>
									<TableHead>Тип</TableHead>
								</TableRow>
							</TableHeader>
							<TableBody>
								{SYSTEM_VARIABLES.map((variable) => (
									<TableRow key={variable.name}>
										<TableCell>{variable.description}</TableCell>
										<CodeCell name={variable.name} />
										<TableCell className="text-muted-foreground">Базовая</TableCell>
									</TableRow>
								))}
								{draft.variables.map((variable) => (
									<TableRow key={variable.id}>
										<TableCell>
											{variable.description?.replace(/^Botmaker: /, "") || variable.name}
										</TableCell>
										<CodeCell name={variable.name} />
										<TableCell>{VARIABLE_TYPE_LABELS[variable.type]}</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</div>
					<VariablesDialog open={open} onOpenChange={setOpen} draft={draft} actions={actions} />
				</WorkspaceSection>
			)}
		</WithDraft>
	)
}
